package com.essntl.features.address.data.supabase

import com.essntl.features.address.domain.model.AddressModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun AddressModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["line_1"] = JsonPrimitive(line1)

    requestMap["city"] = JsonPrimitive(city)

    requestMap["country"] = JsonPrimitive(country)

    line2?.let {
        requestMap["line_2"] = JsonPrimitive(it)
    }

    state?.let {
        requestMap["state"] = JsonPrimitive(it)
    }

    zipCode?.let {
        requestMap["zip_code"] = JsonPrimitive(it)
    }

    latitude?.let {
        requestMap["latitude"] = JsonPrimitive(it)
    }

    longitude?.let {
        requestMap["longitude"] = JsonPrimitive(it)
    }

    return requestMap
}